import * as Long from "long";
import { ofType } from "redux-observable";
import { merge, of } from "rxjs";
import { catchError, switchMap, switchMapTo } from "rxjs/operators";
import { CommandCode, } from "../../../../utils/network/generated/protoTypes";
import { utilBuildings } from "../../../../utils/utilBuildings";
import { actionBaseInfoAddBuilding, actionBaseInfoRemoveBuilding, } from "../../../info/base/actionBaseInfo";
import { actionInventoryInfoAddBuilding } from "../../../info/inventory/actionInventoryInfo";
import { actionBuildingsDeselect, TypeActionBuildings } from "../actionBuildings";
export var epicBuildingsStoreBuilding = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionBuildings.StoreBuilding), switchMap(function (action) {
        var state = state$.value;
        var items = [
            {
                amount: Long.ONE,
                stageId: utilBuildings.getProtoStage(action.building),
                typeId: action.building.balancing.id,
            },
        ];
        var request$ = deps
            .netSend({
            id: CommandCode.StoreBuilding,
            props: {
                buildingId: action.building.proto.id,
                farmId: state.playerBase.base.baseId,
                playerId: state.playerInfo.playerId,
            },
        })
            .pipe(switchMapTo(of(actionInventoryInfoAddBuilding(items))), catchError(function () { return of(actionBaseInfoAddBuilding(action.building.proto)); }));
        return merge(request$, of(actionBuildingsDeselect()), of(actionBaseInfoRemoveBuilding(action.building.proto)));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/epics/epicBuildingsStoreBuilding.ts
// module id = 2090
// module chunks = 3